<template>
  <component :is="component">{{ converted }}</component>
</template>

<script>
import * as dateHelper from '@/utils/date-helper'

export default {
  name: 'BrbDateTimeDisplay',
  props: {
    date: {
      validator: (value) =>
        value === null ||
        typeof value === 'string' ||
        typeof value === 'number',
      required: true
    },
    component: {
      type: String,
      default: 'span'
    },
    dateTime: Boolean,
    time: Boolean,
    dayName: Boolean,
    dayNameDate: Boolean,
    dayNameDateTime: Boolean,
    dayNameMonthNameYear: Boolean,
    dayNameMonthNameYearTime: Boolean,
    secsToTime: Boolean
  },
  computed: {
    converted() {
      if (!this.date) return null

      if (this.date === this.$config.infinitTime) return '∞'

      if (this.dateTime)
        return `${dateHelper.jalaaliFullDate(
          this.date
        )} - ${dateHelper.jalaaliTime(this.date)}`

      if (this.dayName) return dateHelper.jalaaliWeekDayName(this.date)

      if (this.time) return dateHelper.jalaaliTime(this.date)

      if (this.dayNameDate)
        return `${dateHelper.jalaaliWeekDayName(
          this.date
        )}، ${dateHelper.jalaaliFullDate(this.date)} `

      if (this.dayNameDateTime)
        return `${dateHelper.jalaaliWeekDayName(
          this.date
        )}، ${dateHelper.jalaaliFullDate(this.date)} - ${dateHelper.jalaaliTime(
          this.date
        )}`

      if (this.dayNameMonthNameYear)
        return `${dateHelper.jalaaliWeekDayName(
          this.date
        )}، ${dateHelper.jalaaliDayOfMonth(
          this.date
        )} ${dateHelper.jalaaliMonthName(this.date)} ${dateHelper.jalaaliYear(
          this.date
        )}`

      if (this.dayNameMonthNameYearTime)
        return `${dateHelper.jalaaliWeekDayName(
          this.date
        )}، ${dateHelper.jalaaliDayOfMonth(
          this.date
        )} ${dateHelper.jalaaliMonthName(this.date)} ${dateHelper.jalaaliYear(
          this.date
        )} - ${dateHelper.jalaaliTime(this.date)}`

      if (this.secsToTime) {
        const result = dateHelper.ssToHhMm(this.date)
        if (!result) return null
        return `${
          result.hour ? `${result.hour} ${this.$t('units.hour')}` : ''
        }${result.hour && result.minutes ? ` ${this.$t('shared.and')} ` : ''}${
          result.minutes ? `${result.minutes} ${this.$t('units.minutes')}` : ''
        }`
      }

      return dateHelper.jalaaliFullDate(this.date)
    }
  }
}
</script>
